import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';
import { usePopper } from 'react-popper';

import './MoreOptionsButton.css';

export default function MoreOptionsButton({ onTogglePopper, isPopperOpen, options }) {
  const togglerRef = useRef(null);
  const popperRef = useRef(null);

  const { styles, update: updatePopper } = usePopper(togglerRef.current, popperRef.current, {
    placement: 'bottom-end',
    modifiers: [
      {
        name: 'computeStyles',
        options: {
          adaptive: false,
        },
      },
    ],
  });

  useEffect(() => {
    if (updatePopper) updatePopper();
  }, [isPopperOpen, updatePopper]);

  useEffect(() => {
    function closePopper(e) {
      if (!popperRef.current.contains(e.target) && !togglerRef.current.contains(e.target)) {
        onTogglePopper(false);
      }
    }

    window.addEventListener('click', closePopper, false);

    return () => window.removeEventListener('click', closePopper, false);
  }, [onTogglePopper]);

  return (
    <div className="more-options-button-popper">
      <button className="actions-btn" type="button" onClick={() => onTogglePopper(!isPopperOpen)} ref={togglerRef}>
        <i className="icon-options-dots" />
      </button>

      <div ref={popperRef} style={styles.popper} className="pop-over-ref">
        {isPopperOpen && (
          <div>
            <div className="more-options-popover">
              {options.map(({ classModifier = '', ...option }) => (
                <button
                  key={option.title}
                  className={`more-options-item ${classModifier}`}
                  type="button"
                  onClick={option.onClickHandler}
                >
                  {option.icon}
                  {option.title}
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

MoreOptionsButton.propTypes = {
  onTogglePopper: PropTypes.func.isRequired,
  isPopperOpen: PropTypes.bool.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      onClickHandler: PropTypes.func.isRequired,
      icon: PropTypes.node,
      classModifier: PropTypes.string,
    })
  ).isRequired,
};
